<template>
    <div
        class="tab-bar-item"
        @click="itemClick"
        @mouseenter="itemHover"
        @mouseleave="itemLeave"
    >
        <div class="nav">
            <slot name="item-text"></slot>
            <p v-if="isActive && !hasSecond"></p>
        </div>
        <img
            src="~assets/images/common/caretTopImg.png"
            v-if="showSecond"
            class="caretTopImg"
            alt=""
        />
        <div class="secondNav" v-if="showSecond">
            <slot name="item-second-nav"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "TarBarItem",
    props: {
        path: {
            type: String,
        },
        hasSecond: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            showSecond: false,
        };
    },
    methods: {
        itemClick() {
            if(!this.hasSecond){
                this.$router.push(this.path);
                document.documentElement.scrollTop = 0;
            }
        },
        itemHover() {
            if (this.hasSecond) {
                this.showSecond = true;
            }
        },
        itemLeave() {
            this.showSecond = false;
        },
    },
    computed: {
        isActive() {
            return this.$route.path.indexOf(this.path) !== -1;
        },
    },
};
</script>

<style scoped lang="less">
.sNav {
    p {
        font-size: 14px;
        font-family: "Microsoft YaHei";
        line-height: 2.286;
        color: #242424;
    }
    p:hover {
        color: rgb(19, 61, 147);
    }
}
.secondNav {
    position: absolute;
    top: 70px;
    left: 0;
    z-index: 12;
    padding: 10px 0;
    width: 100%;
    background: #fff;
}
.tab-bar-item {
    position: relative;
    width: 99px;
    text-align: center;
    height: 70px;
    font-size: 14px;
    color: black;
    font-size: 16px;
    cursor: pointer;
    > .nav {
        line-height: 70px;
    }
    > .caretTopImg {
        position: absolute;
        top: 59px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 12;
    }
}
.nav p {
    position: absolute;
    top: 64px;
    left: 50%;
    transform: translateX(-50%);
    width: 76%;
    height: 6px;
    background: #0647aa;
}
</style>
